import React from 'react'
import useAccount from '../hooks/useAccount'
import useTablePath from '../hooks/useTablePath'
import useRouter from '../hooks/useRouter'
import SpecEditor from '../components/spec-editor/SpecEditor'

// Parse labels from URL parameter
const parseLabelsParam = (labelsParam: string | undefined): Record<string, string[]> => {
  if (!labelsParam) return {}
  try {
    return JSON.parse(decodeURIComponent(labelsParam))
  } catch {
    return {}
  }
}

/**
 * Route wrapper for /editspec/:customer/:job.
 *
 * Everything the editor needs comes off the URL here, so the editor itself
 * stays route-free and can also be rendered inside the dashboard chart
 * widget's Edit Data overlay (#968). Only here does the editor register its
 * page tools (registerPageTools): this is the page on screen.
 */
export const EditSpec: React.FC = () => {
  const account = useAccount()
  const router = useRouter()

  const {
    customer,
    job,
    table,
    tableTitle,
  } = useTablePath()

  // AutoCoder mode round-trips through the Tables page and comes back in the URL
  const isAutoCoderFromUrl = router.params.storageDriver === 'autocoder'

  const handleCancel = () => {
    if (table) {
      account.openPage('tables', { table })
    } else {
      account.openPage('tables')
    }
  }

  return (
    <SpecEditor
      customer={customer}
      job={job}
      table={table}
      tableTitle={tableTitle}
      initialDriver={isAutoCoderFromUrl ? 'autocoder' : 'carbon'}
      initialLabels={parseLabelsParam(router.params.acLabels)}
      initialSyntax={isAutoCoderFromUrl ? {
        top: router.params.acTop || '',
        side: router.params.acSide || '',
        filter: router.params.acFilter || '',
      } : undefined}
      onCancel={handleCancel}
      registerPageTools
    />
  )
}

export default EditSpec
